// Bouton présent dans les supers pièces
import React from "react";
import { Image, ImageStyle, Platform, TextStyle, TouchableOpacity, TouchableOpacityProps } from "react-native";
import Text from "../ReactNative/Text";
import View from "../ReactNative/View";
import AppTheme from "../../utils/Theme";
import Divider from "../../designSystem/Divider/Divider";
import * as Navigation from "../../../specific/utils/Navigation/Navigation";
import { getStringFromMatrixLocalizedString, MatrixLocalizedString } from "../../screens/rooms/FamilyRoom";
import Category from "../../models/Category";
import { getImageSource } from "../../utils/Images/ImagesUtils";
import Colors from "../../Theme/Colors";
import { analyticsEventHpWellBeingResourcesClicked, analyticsEventSectionTrainingCPSClicked, analyticsEventSectionTrainingPhiloClicked, trackEvent } from "../../services/Tracking/Analytics";
import { ScreenCategoryHome } from "../../utils/Constants";
import { useNavigate } from "../../../specific/utils/Navigation/Navigation";

interface CategoryButtonProps extends TouchableOpacityProps {
    category_key: string;
    title?: MatrixLocalizedString;
    body?: MatrixLocalizedString;
    category: Category;
    componentId?: string;
    forcedWidth?: number;
}

const CategoryButton = (props: CategoryButtonProps) => {

    const { category_key, title, body, category, componentId = "",  forcedWidth = 430, ...restProps } = props;
    const appTheme: AppTheme = new AppTheme();

    let navigate = null;
    if (Platform.OS === "web") {
        navigate = useNavigate()
    }

    let blocksWidth: number = appTheme.getFullAppWidth() - appTheme.pixelPerfect(40);
    let bottomBlocksWidth: number = appTheme.getFlexDirectionForSplitScreen() === "row" ? forcedWidth !== undefined ? forcedWidth : 430 : blocksWidth;

    const sectionImageStyle: ImageStyle = {
        width: bottomBlocksWidth,
        height: Platform.OS === "web" ? bottomBlocksWidth * 7 / 16 : bottomBlocksWidth * 7 / 16
    }

    const sectionTitleStyle: TextStyle = {
        color: appTheme.textColor,
        fontFamily: appTheme.superHerosFontBold,
        fontSize: appTheme.pixelPerfectForFont(9),
        alignItems: "center",
        textAlign: "center",
        textTransform: "uppercase",
        width: "100%",
        paddingHorizontal: appTheme.pixelPerfect(4)
    }

    const sectionBodyStyle: TextStyle = {
        fontFamily: appTheme.primaryMediumFont,
        fontSize: Platform.OS === "web" ? appTheme.pixelPerfectForFont(9) : appTheme.pixelPerfectForFont(10),
        color: appTheme.darkBlue,
        paddingHorizontal: appTheme.pixelPerfect(20),
        textAlign: "center"
    }

    const launchSection = () => {
        if (category_key === "wellBeing") {
            trackEvent(analyticsEventHpWellBeingResourcesClicked);
        } else if (category_key === "philo") {
            trackEvent(analyticsEventSectionTrainingPhiloClicked);
        } else if (category_key === "cps") {
            trackEvent(analyticsEventSectionTrainingCPSClicked);
        }
        Navigation.push({
            componentId,
            navigate,
            name: ScreenCategoryHome,
            passProps: {
                categoryKey: category_key,
                section: "room",
                origin: "menu"
            }
        });
    }

    const renderTitle = () => {
        if (title === undefined) {
            return null;
        }
        return <Text style={sectionTitleStyle}>{getStringFromMatrixLocalizedString(title)}</Text>
    }

    const renderBody = () => {
        if (body === undefined) {
            return null;
        }
        return <Text style={sectionBodyStyle}>{getStringFromMatrixLocalizedString(body)}</Text>
    }

    const renderHeaderImg = () => {
        const imageSource: number | { uri: string } = getImageSource({ app_image: category.img?.header?.local, img_url: category.img?.header?.web });
        return <Image source={imageSource} style={sectionImageStyle} />;
    }

    const getBackgroundColor = (): string => {
        if (category.clr !== undefined) {
            if (category.clr.bottom !== undefined) {
                return category.clr.bottom;
            }
            if (category.clr.header_bg !== undefined) {
                return category.clr.header_bg;
            }
        }
        return "#FFFFFF";
    }

    return <TouchableOpacity key={category_key} onPress={launchSection} style={{ alignItems: "center", justifyContent: "center", width: bottomBlocksWidth, flexDirection: "row" }}>
        <View style={{ alignItems: "center", justifyContent: "flex-start", width: bottomBlocksWidth, paddingTop: appTheme.pixelPerfect(10) }}>
            <View style={{ paddingBottom: appTheme.pixelPerfect(20), width: bottomBlocksWidth, backgroundColor: getBackgroundColor(), borderRadius: appTheme.pixelPerfect(10), alignItems: "center", overflow: "hidden" }}>
                {renderHeaderImg()}
                {renderTitle()}
                <Divider />
                {renderBody()}
            </View>
        </View>
    </TouchableOpacity>

}

export default CategoryButton;